import * as React from 'react';
import {useJsonForms, withJsonFormsControlProps} from '@jsonforms/react';
import Columns from './Columns';
import {SchemaUtils} from "../../util/SchemaUtils";
import {ControlValueFactory} from "../../factory/ControlValueFactory";
import {Component} from "../../enum/Component";

interface ColumnsControlProps {
    data: any;
    handleChange(path: string, value: Array<any>): void;
    path: string;
    errors: any;
    uischema: any;
    schema: any;
    rootSchema: any;
    appValidated?: boolean;
}

const ColumnsControl = ({ errors, uischema, schema, handleChange, path, rootSchema, data, appValidated}: ColumnsControlProps) => {

    const jsonForms = useJsonForms();

    let enabled = SchemaUtils.isComponentEnabled(uischema, jsonForms.core!.data);
    let visible = SchemaUtils.isComponentVisible(uischema, jsonForms.core!.data);
    let required = SchemaUtils.isRequired(path, rootSchema);

    const componentSchema = SchemaUtils.getComponentSchema(path, rootSchema);
    const allowAddRows = componentSchema?.allowAddRows !== undefined ? componentSchema.allowAddRows : true;
    const description = componentSchema?.description || uischema.description || '';

    function handleColumnsChange(newValue: Array<any>){
        handleChange(path, newValue);
    }

    let value = ControlValueFactory.getControlValue(Component.Columns, data, uischema.scope, jsonForms,enabled && visible);

    return (
        <Columns
            visible={visible}
            value={value}
            variant='outlined'
            label={uischema.label}
            description={description}
            required={required}
            error={errors}
            onChange={handleColumnsChange}
            uischema={uischema}
            schema={schema}
            appValidated={appValidated}
            allowAddRows={allowAddRows}
        />
    );
}

export default withJsonFormsControlProps(ColumnsControl);
